import styled from 'styled-components';

export const Card = styled.div`
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px 0px,
    rgba(0, 0, 0, 0.19) 0px 6px 20px 0px;
  background-color: white;
  border-radius: 10px;
`;
